import React, { ReactNode } from 'react'
import { useForm, Control, useFormState, FieldValues } from 'react-hook-form'
import { Button } from 'reactstrap'

// TODO: Get rid of ICON ???
interface ICSSubmitButtonProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  icon?: ReactNode // Icon component or element
  className?: string
  children: ReactNode // Button text (or nested content)
}

const ICSSubmitButton = <TFieldValues extends FieldValues>({
  control,
  icon,
  className,
  children
}: ICSSubmitButtonProps<TFieldValues>) => {
  const { isSubmitted, isDirty, isValid } = useFormState({
    control
  })

  // TODO: ICSButton uses devExtreme button, need to create a generic form button
  return (
    <Button
      color="success"
      className={className}
      type="submit"
      disabled={isSubmitted || !isValid || !isDirty}
    >
      {icon && <span className="me-2">{icon}</span>}
      {children}
    </Button>
  )
}

export default ICSSubmitButton

ICSSubmitButton
